export default __webpack_public_path__ + "media/images/icons/task_alt-a0e5ad88afb6f58e556f581274a99fd9.svg";